import { render, staticRenderFns } from "./RequestPageEditorPage.vue?vue&type=template&id=08f0dba6&scoped=true"
import script from "./RequestPageEditorPage.vue?vue&type=script&lang=ts"
export * from "./RequestPageEditorPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0dba6",
  null
  
)

export default component.exports